import { Icon, IconButton } from "../../../atoms";
import { useSortableItem } from "./SortableListItem";
import type { SortableTriggerProps } from "../List.types";

const SortableTrigger = (props: SortableTriggerProps) => {
  const { attributes, listeners } = useSortableItem();
  const icon = props.icon || <Icon icon='Drag' style="Outlined" />;
  return <IconButton 
    {...props}
    {...attributes}
    {...listeners}
    icon={icon}
  />;
};

export default SortableTrigger;